import React from "react";

const ErrorPage = () => (
  <div className="error-page">
    <h1>Whoops! Something went wrong</h1>
    <p>
      Unfortunately we&apos;ve encountered an unexpected error.
      <br />
      Our developer team has been notified and will resolve this as soon as
      possible.
      <br />
      In the meantime, please try refreshing the page and trying again, or give
      us a call on 020 4571 5217.
    </p>
  </div>
);

export default ErrorPage;
